import { useApp } from '@/context/AppContext';
import AddCustomerModal from './modals/AddCustomerModal';
import AddJobModal      from './modals/AddJobModal';
import AddInvoiceModal  from './modals/AddInvoiceModal';
import SendMessageModal from './modals/SendMessageModal';
import ExportModal      from './modals/ExportModal';
import ImportCustomersModal from './modals/ImportCustomersModal';

export default function Modal() {
  const { modal, closeModal } = useApp();
  if (!modal) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) closeModal();
  };

  const content = (() => {
    switch (modal.type) {
      case 'add_customer':     return <AddCustomerModal data={modal.data} />;
      case 'add_job':          return <AddJobModal data={modal.data} />;
      case 'add_invoice':      return <AddInvoiceModal data={modal.data} />;
      case 'send_message':     return <SendMessageModal data={modal.data} />;
      case 'export':           return <ExportModal data={modal.data} />;
      case 'import_customers': return <ImportCustomersModal data={modal.data} />;
      default:                 return null;
    }
  })();

  if (!content) return null;

  return (
    <div className="overlay" onClick={handleOverlayClick}>
      {content}
    </div>
  );
}
